import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const IS_QUESTION_CHANGE = 'IS_QUESTION_CHANGE';

interface CertificationConfiguration {
  certification_config?: any;
  property?: any;
  updated?: Date;
  last_publish?: Date;
  [key: string]: any;
}

interface State {
  isLoading: boolean;
  error: boolean | string | null;
  certificationConfiguration: CertificationConfiguration;
}

const initialState: State = {
  isLoading: false,
  error: false,
  certificationConfiguration: {},
};

const slice = createSlice({
  name: 'Certification Configuration Workbench',
  initialState,
  reducers: {
    startLoading(state: State) {
      state.isLoading = true;
    },

    hasError(state: State, action: PayloadAction<boolean | string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCertificationConfigSuccess(
      state: State,
      action: PayloadAction<CertificationConfiguration>
    ) {
      state.isLoading = false;
      state.certificationConfiguration = action.payload;
    },

    setCertificationConfiguration(
      state: State,
      action: PayloadAction<CertificationConfiguration>
    ) {
      const certConfig = action.payload;

      if (certConfig?.updated) {
        certConfig.updated = new Date(certConfig.updated);
      }
      if (certConfig?.last_publish) {
        certConfig.last_publish = new Date(certConfig.last_publish);
      }

      state.certificationConfiguration = certConfig;
    },

    configUpdated(state: State, action: PayloadAction<string | null>) {
      const payload = action?.payload;

      const isTemplate = !(
        state?.certificationConfiguration?.certification_config &&
        state?.certificationConfiguration?.property
      );
      const isQuestionChange = payload === IS_QUESTION_CHANGE;

      if (isTemplate) {
        state.certificationConfiguration = {
          ...state.certificationConfiguration,
          updated: new Date(),
        };
      }

      if (!isTemplate && isQuestionChange) {
        state.certificationConfiguration = {
          ...state.certificationConfiguration,
          last_publish: new Date(),
        };
      }
    },
  },
});

export default slice.reducer;
export const { setCertificationConfiguration, configUpdated } = slice.actions;
